module.exports = __webpack_public_path__ + "static/footer-6-8774f044cb469be6a80d73663ab3c2a7.mp4";